<script>
export default {
    components: {
    },

    mounted() {
        this.$store.commit("sites/setHideSiteModal", true);
    },
    destroyed() {
        this.$store.commit("sites/setHideSiteModal", false); 
    }
};
</script>

<template>
    <VpConfirmModal :modalId="'locationPolicyConfirmModal'" :alignLeft="true">
    <template v-slot:title>
      <span>{{ $t("sitesAndDevices.locationPrivacy") }}</span>
    </template>

    <template v-slot:text1>
      <span><strong>{{ $t('sitesAndDevices.localPrivacy')}}</strong></span>
    </template>

    <template v-slot:text2>
      <span>{{ $t('sitesAndDevices.localPrivacyNote')}}</span>
    </template>

    <template v-slot:text1-1>
      <span><strong>{{ $t('sitesAndDevices.signInReminder')}}</strong></span>
    </template>

    <template v-slot:text3>
      <span>{{ $t('sitesAndDevices.proximityReminder')}}</span>
    </template>

    <template v-slot:buttons>
      <VpButton :text="$t('common.okay')" @click="$bvModal.hide('locationPolicyConfirmModal')" />
    </template>
  </VpConfirmModal>
</template>
